import React, { useState } from 'react';
import { useTheme } from './ThemeContext';
import { Sun, Moon, Droplets, Layers } from 'lucide-react';

export default function ThemeSelector() {
  const { theme, setTheme, themes } = useTheme();
  const [open, setOpen] = useState(false);

  const items = [
    { key: 'light', label: 'Light', icon: Sun },
    { key: 'dark', label: 'Dark', icon: Moon },
    { key: 'ocean', label: 'Ocean', icon: Droplets },
    { key: 'glass', label: 'Glass', icon: Layers },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-[999]">
      {/* Main Button */}
      <button
        onClick={() => setOpen(!open)}
        className="w-12 h-12 rounded-full bg-card text-text shadow-glass flex items-center justify-center hover:scale-110 transition"
      >
        🎨
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute bottom-14 right-0 bg-card border border-border rounded-xl shadow-glass p-2 w-40">
          {items.map(item => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                onClick={() => {
                  setTheme(item.key);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition
                  ${theme === item.key
                    ? 'bg-blue-500/20 text-blue-500'
                    : 'hover:bg-gray-500/10 text-text'
                  }`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
